<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><mask id="mask0_748_46427" maskUnits="userSpaceOnUse" x="2" y="0" width="16" height="20"><path d="M3.103 0h10.24c.146 0 .285.056.389.157l4.105 3.985c.104.101.163.24.163.384v14.393c0 .597-.494 1.081-1.103 1.081H3.103C2.494 20 2 19.516 2 18.919V1.08C2 .484 2.494 0 3.103 0Z" fill="#fff" stroke="transparent"></path></mask><g mask="url(#mask0_748_46427)" stroke="transparent"><path d="M3.103 0h10.24c.146 0 .285.056.389.157l4.105 3.985c.104.101.163.24.163.384v14.393c0 .597-.494 1.081-1.103 1.081H3.103C2.494 20 2 19.516 2 18.919V1.08C2 .484 2.494 0 3.103 0Z" fill="#165DFF"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.57 0h4.414v4.324h-3.31c-.61 0-1.104-.484-1.104-1.08V0Z" fill="#94BFFF"></path></g><path d="M10.004 10.158 8.53 15.615a.152.152 0 0 1-.147.112h-.868a.152.152 0 0 1-.146-.11l-2-7.06a.152.152 0 0 1 .146-.194h.871c.07 0 .13.047.147.114l1.423 5.503 1.478-5.504a.152.152 0 0 1 .146-.113h.849c.069 0 .129.047.147.113l1.468 5.503 1.422-5.502a.152.152 0 0 1 .147-.114h.871a.152.152 0 0 1 .146.193l-2 7.06a.152.152 0 0 1-.145.11h-.869a.152.152 0 0 1-.146-.112l-1.466-5.456Z" fill="#fff" stroke="transparent"></path></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconFileWordColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-file-word-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
